import React, { useState } from 'react';
import { Upload, message, Progress, Image } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import rootApi from '@utils/baseAPI/WrapperApi';

const InputUploadImage = ({ onChange, initValue, disabled }) => {
  const [fileList, setFileList] = useState(initValue?.url ? [initValue] : []); // State for the file list
  const [uploadProgress, setUploadProgress] = useState(0); // State for upload progress
  const [uploading, setUploading] = useState(false); // State for upload status
  const [localPreview, setLocalPreview] = useState(null); // State for local preview URL

  const handleUpload = async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    try {
      setUploading(true);
      const response = await rootApi.post('api/file/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress(percentCompleted); // Update progress
        }
      });

      // Convert Google Drive link to a direct link if necessary
      let fileUrl = response.data?.data?.webViewLink;
      if (fileUrl && fileUrl.includes('drive.google.com')) {
        const fileId = fileUrl.split('/d/')[1]?.split('/')[0];
        fileUrl = `https://drive.google.com/uc?export=view&id=${response.data?.data?.id}`;
      }
      // Replace the file list with the newly uploaded file
      const uploadedFile = {
        uid: file.uid, // Unique identifier for the file
        name: file.name,
        status: 'done',
        url: fileUrl // Use the direct link
      };
      setFileList([uploadedFile]); // Replace the file list with the new file
      onChange && onChange(uploadedFile);
      message.success('Tải lên file thành công!');
    } catch (error) {
      console.error('Error uploading file:', error);
      message.error('Tải lên thất bại!');
    } finally {
      setUploading(false);
      setUploadProgress(0); // Reset progress
    }
  };

  const beforeUpload = (file) => {
    if (!file.type.startsWith('image/')) {
      message.error('You can only upload image files!');
      return false;
    }

    // Generate a local preview URL for the selected file
    const reader = new FileReader();
    reader.onload = (e) => {
      setLocalPreview(e.target.result); // Set the local preview URL
    };
    reader.readAsDataURL(file);

    // Automatically upload the file after selection
    handleUpload(file);

    return false; // Prevent automatic upload by Ant Design
  };

  const props = {
    disabled,
    accept: 'image/*', // Accept only image files
    beforeUpload,
    // listType: 'picture', // Display uploaded files as pictures
    fileList, // Bind the file list to the Upload component
    onRemove: () => {
      // Clear the file list and local preview when the file is removed
      setFileList([]);
      setLocalPreview(null);
      onChange && onChange(null); // Notify parent component about the removal
    }
  };

  return (
    <div
      style={{
        border: '1px dashed  #d9d9d9',
        borderRadius: '8px',
        padding: '16px',
        textAlign: 'center',
        backgroundColor: '#fff'
      }}>
      <Upload {...props}>
        {fileList.length === 0 && !localPreview && (
          <div>
            <UploadOutlined style={{ fontSize: '24px', color: '#0174CF' }} />
            <div style={{ marginTop: 8 }}>Nhấn hoặc kéo file vào đây để tải lên</div>
          </div>
        )}
        {localPreview && (
          <img
            src={localPreview}
            alt="Preview"
            style={{
              maxWidth: '100%',
              maxHeight: '200px',
              borderRadius: '8px',
              pointerEvents: 'none'
            }}
          />
        )}
      </Upload>
      {uploading && (
        <div style={{ marginTop: 16 }}>
          <Progress percent={uploadProgress} />
        </div>
      )}
    </div>
  );
};

export default InputUploadImage;
